import CustomTitle from "../../../components/CustomMiscellaneous/CustomTitle";
import TableView from "../../Common/TableView";
import { NotasCreditoFornecedoresTableConfigs } from "./NotasCreditoFornecedores.config";
import { generalObjectBuilder, genericDelete, genericGetWithProcessor, genericPost, genericUpdate, NOTAS_CREDITO_FORNECEDORES_EXTENSION, paginatedGetWithProcessor } from "../../../services/api.service";


export default function NotasCreditoFornecedores() {

    return (<div>
        <TableView
                title={"Notas de Crédito Fornecedores"}

            postEntity={genericPost(NOTAS_CREDITO_FORNECEDORES_EXTENSION)}
            editEntity={genericUpdate(NOTAS_CREDITO_FORNECEDORES_EXTENSION)}
            deleteEntity={genericDelete(NOTAS_CREDITO_FORNECEDORES_EXTENSION)}
            addButtonText={"Nova Nota de crédito"}
            tableConfigs={NotasCreditoFornecedoresTableConfigs}
            dataBuildFunction={generalObjectBuilder(NotasCreditoFornecedoresTableConfigs)}
            entityName={"Nota de Crédito Fornecedor"}
            idProp={"code"}
            reroute={true}
            configMapKey={"notas-credito-fornecedores"}
        />
    </div>)

}

